import React from "react";
import { ModalBody, ModalFooter, ModalHeader, Button, Input, Label } from "reactstrap";
import YouTube from "react-youtube";
import AppModal from "components/AppModal";

import coinInfoImage from "assets/img/custom/coin-info.png";
import adModalImg from "../../../assets/img/custom/adModalImg.png";
import fhpCoinInfo from "../../../assets/img/custom/fhpCoinInfo.jpg";
import schoolDiscountImage from "../../../assets/img/custom/schoolDiscountImage.jpg";
import vendorDiscountImage from "../../../assets/img/custom/vendorDiscount.jpg";
import gameStayDay from "../../../assets/img/custom/gameStayDay.jpg";
import tokenPool from "../../../assets/img/custom/tokenPool.jpg";
import fhpCoinToken from "../../../assets/img/custom/fhpCoinToken.jpg";
import fanSkillContestImage from "../../../assets/img/custom/fanSkillContestmage.jpg";
import Apple1 from "../../../assets/img/custom/step1.PNG";
import Apple2 from "../../../assets/img/custom/step 2.png";
import Apple3 from "../../../assets/img/custom/step 3.PNG";
import Android1 from "../../../assets/img/custom/android_1.jpg";
import Android2 from "../../../assets/img/custom/android_2.jpg";
import Android3 from "../../../assets/img/custom/android_3.jpg";
import AndroidStep from "../../../assets/img/custom/androidstep.PNG";
import SafariStep from "../../../assets/img/custom/safaristep.PNG";

const FHP_COMMUNITY_VIDEO =
  "https://firebasestorage.googleapis.com/v0/b/fans-help-players.appspot.com/o/FHP%20Sports%20Community.mp4?alt=media&token=1bf1990b-f2d5-40c3-aeb8-7c9568a8816f";

const SPORTS_MEME_VIDEO =
  "https://firebasestorage.googleapis.com/v0/b/fans-help-players.appspot.com/o/Sports%20Meme%20Reel.mp4?alt=media&token=9e294941-f6e4-4d3d-9142-bc94c43d063a";

export default function HomeModals({
  // coin info
  coinInfoOpen, toggleCoinInfo,
  // apple install
  appleModal, appleToggle, active, setActive,
  // android install
  androidModal, androidToggle,
  // register notice
  registerModal, registerNoticeToggle, registerNotice, setRegisterNotice, history,
  // athlete video carousel
  modal, Modaltoggle, videoId, currentVideo, handleVideoStateChange,
  // image preview
  imgModal, toggleImgModal, showModalImg,
  // ad modal
  adModalOpen, toggleAdModal,
  // disclaimer
  isDisclaimerOpen, disclaimerToggle,
  // membership
  membershipModal, toggleMemberShipModal,
  // fhp coin
  fhpCoinModal, toggleFhpCoinModal,
  // school discount
  schoolDiscountModal, toggleSchoolDiscount,
  // vendor discount
  vendorDiscountModal, toggleVendorDiscount,
  // game day stay
  gameDayStayModal, toggleGameDayStay,
  // token pool
  tokenPoolModal, toggleTokenPool,
  // fhp coin token
  fhpCoinTokenModal, toggleFhpCoinToken,
  // fhp coin video
  fhpCoinVideoModal, toggleFhpCoinVideo,
  // fan skill contest
  fanSkillContest, toggleFanSkillContest,
  // sports meme
  sportsMemeModal, toggleSportsMeme,
  // ncaa info
  isShow, toggle, isShow2, toggle2,
}) {
  return (
    <>
      {/* ── Simple image modals ─────────────────────────────────────── */}
      <AppModal type="image" isOpen={coinInfoOpen} toggle={toggleCoinInfo}
        size="lg" centered src={coinInfoImage} alt="Coin Info" />

      <AppModal type="image" isOpen={adModalOpen} toggle={toggleAdModal}
        size="lg" centered src={adModalImg} alt="Ad Exchange" />

      <AppModal type="image" isOpen={fhpCoinModal} toggle={toggleFhpCoinModal}
        size="lg" src={fhpCoinInfo} alt="FHP Coin Info" />

      <AppModal type="image" isOpen={schoolDiscountModal} toggle={toggleSchoolDiscount}
        size="lg" src={schoolDiscountImage} alt="School Discount" />

      <AppModal type="image" isOpen={vendorDiscountModal} toggle={toggleVendorDiscount}
        size="lg" src={vendorDiscountImage} alt="Vendor Discount" />

      <AppModal type="image" isOpen={gameDayStayModal} toggle={toggleGameDayStay}
        size="lg" src={gameStayDay} alt="Game Day Stay" />

      <AppModal type="image" isOpen={tokenPoolModal} toggle={toggleTokenPool}
        size="xl" src={tokenPool} alt="Token Pool" />

      <AppModal type="image" isOpen={fhpCoinTokenModal} toggle={toggleFhpCoinToken}
        size="lg" src={fhpCoinToken} alt="FHP Coin Token" />

      <AppModal type="image" isOpen={fanSkillContest} toggle={toggleFanSkillContest}
        size="lg" src={fanSkillContestImage} alt="Fan Skill Contest" />

      {/* ── Simple video modals ─────────────────────────────────────── */}
      <AppModal type="video" isOpen={membershipModal} toggle={toggleMemberShipModal}
        src={FHP_COMMUNITY_VIDEO} />

      <AppModal type="video" isOpen={fhpCoinVideoModal} toggle={toggleFhpCoinVideo}
        src={FHP_COMMUNITY_VIDEO} />

      <AppModal type="video" isOpen={sportsMemeModal} toggle={toggleSportsMeme}
        src={SPORTS_MEME_VIDEO} />

      {/* ── Custom modals ───────────────────────────────────────────── */}

      {/* Image preview (dynamic src, OK button) */}
      <AppModal type="custom" isOpen={imgModal} toggle={toggleImgModal} size="lg">
        <img className="mt-2 pointer" src={showModalImg} alt="Preview" width="100%" />
        <div className="d-flex justify-content-end align-items-end my-2 mr-4">
          <Button color="primary" onClick={toggleImgModal}>OK</Button>
        </div>
      </AppModal>

      {/* Disclaimer */}
      <AppModal type="custom" isOpen={isDisclaimerOpen} toggle={disclaimerToggle}>
        <ModalHeader toggle={disclaimerToggle}>Disclaimer</ModalHeader>
        <ModalBody>
          <p className="text-dark m-2">
            Disclaimer Regarding FHPcoin Token Utility and Non-Investment Nature.
            The FHPcoin token provided in connection with transactions at
            FansHelpPlayers.com is a utility token issued solely for the purpose
            of enabling access to, and enhancing use of, certain features,
            goods, services, or discounts offered by the site. The token is not
            offered or sold as an investment, and no person is being solicited
            to purchase the token with any expectation of profit, appreciation,
            resale value, or return on investment. The token is not a security
            and does not represent ownership, equity, or any claim to future
            revenue or voting rights in FansHelpPlayers, LLC. The token may or
            may not be transferable and may or may not ever have a liquid market.
            Any reference to value or price is strictly for denominational
            convenience and not intended to imply a speculative opportunity.
            Neither the Company nor any affiliated party is offering or promoting
            the token as an investment opportunity. By accepting or using the
            token, the recipient acknowledges and agrees to these terms.
          </p>
        </ModalBody>
        <ModalFooter className="text-right">
          <Button color="secondary" onClick={disclaimerToggle}>Close</Button>
        </ModalFooter>
      </AppModal>

      {/* Register Notice */}
      <AppModal type="custom" isOpen={registerModal} toggle={registerNoticeToggle} centered>
        <div className="d-flex p-2">
          <i className="fa fa-times pointer ml-auto text-danger" onClick={registerNoticeToggle}></i>
        </div>
        <ModalBody>
          <strong>BEFORE Registering, read this Notice</strong>
          <Label className="custom-label text-dark">
            Student athletes must independently determine, along with their own
            advisor(s), if registration at this website is in their best interest.
            FansHelpPlayers, LLC does not accept any liability for such registration
            decisions by student athletes. Furthermore, regarding the Brand Ambassador
            Contract herein, Student Athletes are advised to consult his/her Advisor
            regarding the contract.
          </Label>
          <div className="d-flex mt-2 ml-4">
            <Input
              required
              type="checkbox"
              className="custom-checkbox"
              checked={registerNotice}
              onChange={(e) => setRegisterNotice(e.target.checked)}
            />
            <Label className="custom-checkbox-label text-dark mx-4 mt-1">
              I've read the Notice and will comply.
            </Label>
          </div>
          <div className="text-right mt-2">
            <Button
              color="primary"
              disabled={!registerNotice}
              onClick={() => history.push("/auth/login")}
            >
              Continue
            </Button>
            <Button color="danger" onClick={registerNoticeToggle}>Cancel</Button>
          </div>
        </ModalBody>
      </AppModal>

      {/* Apple Install Steps */}
      <AppModal type="custom" isOpen={appleModal} toggle={appleToggle} centered>
        <div className="d-flex p-2">
          <i className="fa fa-times pointer ml-auto text-danger" onClick={appleToggle}></i>
        </div>
        <div className="mx-auto">
          <Button size="sm" color="secondary" disabled={active === 0}
            onClick={() => active !== 0 && setActive(active - 1)}>Prev</Button>
          <Button size="sm" color="primary" disabled={active === 3}
            onClick={() => active !== 3 && setActive(active + 1)}>Next</Button>
        </div>
        <ModalBody className="text-center">
          <img src={SafariStep} alt="Safari Step" className={`${active !== 0 && "d-none"} img-fluid`} />
          <img src={Apple1}    alt="Step 1"      className={`${active !== 1 && "d-none"} img-fluid`} />
          <img src={Apple2}    alt="Step 2"      className={`${active !== 2 && "d-none"} img-fluid`} />
          <p className={`${active !== 3 && "d-none"}`}>
            Click the add button above. This can take a few minutes to load up your mobile screen.
            You can close this screen.
          </p>
          <img src={Apple3} alt="Step 3" className={`${active !== 3 && "d-none"} img-fluid`} />
        </ModalBody>
      </AppModal>

      {/* Android Install Steps */}
      <AppModal type="custom" isOpen={androidModal} toggle={androidToggle} centered>
        <div className="d-flex p-2">
          <i className="fa fa-times pointer ml-auto text-danger" onClick={androidToggle}></i>
        </div>
        <div className="mx-auto">
          <Button size="sm" color="secondary" disabled={active === 0}
            onClick={() => active !== 0 && setActive(active - 1)}>Prev</Button>
          <Button size="sm" color="primary" disabled={active === 3}
            onClick={() => active !== 3 && setActive(active + 1)}>Next</Button>
        </div>
        <ModalBody className="text-center">
          <img src={AndroidStep} alt="Android Step" className={`${active !== 0 && "d-none"} img-fluid`} />
          <img src={Android1}    alt="Step 1"       className={`${active !== 1 && "d-none"} img-fluid`} />
          <img src={Android2}    alt="Step 2"       className={`${active !== 2 && "d-none"} img-fluid`} />
          <img src={Android3}    alt="Step 3"       className={`${active !== 3 && "d-none"} img-fluid`} />
        </ModalBody>
      </AppModal>

      {/* Athlete Video Carousel */}
      <AppModal type="custom" isOpen={modal} toggle={Modaltoggle} size="lg">
        <div className="px-2 text-center">
          <h2 className="mt-4 text-center">Athlete Video Highlights</h2>
          {videoId && currentVideo?.athleteID ? (
            <>
              <YouTube
                videoId={videoId}
                onStateChange={handleVideoStateChange}
                opts={{
                  width: "100%",
                  height: "auto",
                  playerVars: { autoplay: 1, mute: 0, modestbranding: 1, controls: 0 },
                }}
              />
              <h2>Athlete ID: <b>{currentVideo.athleteID}</b></h2>
              <h2>
                Athlete Name: <b>{currentVideo.first_name} {currentVideo.last_name}</b>
              </h2>
            </>
          ) : (
            <div className="container mt-5 text-center">
              <h2 className="mb-4">Videos Finished</h2>
            </div>
          )}
        </div>
        <div className="d-flex justify-content-end align-items-end my-2 mr-4">
          <Button color="danger" onClick={Modaltoggle}>Close</Button>
        </div>
      </AppModal>

      {/* NCAA Guidance */}
      <AppModal type="custom" isOpen={isShow} toggle={toggle} size="lg" centered>
        <ModalBody>
          <div className="font-weight-600">
            <p>
              The NCAA <b><u>guidance</u></b> approved on 26 October 2022 clarifies how
              schools can interact and support enrolled student-athletes' NIL activities.
            </p>
            <p>
              a. Schools are encouraged to provide educational training to current
              student-athletes on such topics as financial literacy, taxes,
              entrepreneurship, and social media practices. According to the guidance,
              these educational programs also can be provided to collectives, boosters,
              and prospective student-athletes.
            </p>
            <p>
              <p className="m-0">b. With respect to supporting student-athlete activities:</p>{" "}
              Schools <b><u>are</u></b> allowed to: administer a marketplace that matches
              student-athletes with NIL opportunities; arrange space for NIL entities and
              student-athletes to meet on campus or in school facilities; and promote
              student-athlete NIL activity on paid platforms, provided that the
              student-athlete or NIL entity is paying the going rate for the advertisement.
            </p>
            <p>
              c. Schools are <b><u>not</u></b> allowed to: communicate with NIL entities
              regarding specific student-athlete requests or demands for compensation;
              assist proactively in the implementation of a specific student-athlete's NIL
              activity; and provide a student-athlete access to equipment, unless the same
              benefit is generally available to the institution's students.
            </p>
            <p>
              <p className="m-0">d. With respect to supporting NIL entities and collectives:</p>{" "}
              Schools <b><u>are</u></b> allowed to: assist NIL entities in raising money for
              those entities; provide assets (e.g., tickets) to NIL entities under
              sponsorship agreements if those assets are available to other sponsors;
              encourage donors to provide funding to NIL entities if they are not directed
              to a specific sport or student-athlete; and facilitate meetings between donors
              and NIL entities.
            </p>
            <p>
              e. Schools are <b><u>not</u></b> allowed to: subscribe to nor donate cash to
              the NIL entity; provide assets to a donor as an incentive for providing funds
              to the NIL entity; and allow athletics department staff members to be employed
              by an NIL entity.
            </p>
            <p>
              f. Further, schools are <b><u>not</u></b> allowed to engage in certain
              negotiating, revenue sharing, and compensating activities, including to allow
              staff members to represent enrolled student-athletes for NIL deals; or enter
              in contracts with the student-athletes for the sale of products related to NIL
              deals; or engage in student-athlete revenue sharing; or allow coaches to
              compensate student-athletes to promote the coach's camp.
            </p>
          </div>
          <div className="text-right">
            <Button color="danger" onClick={toggle}>Close</Button>
          </div>
        </ModalBody>
      </AppModal>

      {/* NCAA 2023 Update */}
      <AppModal type="custom" isOpen={isShow2} toggle={toggle2} size="lg" centered>
        <ModalBody>
          <div>
            <h2>
              In 2023, the NCAA Division I Board of Directors directed the Division I
              Council to develop proposals to improve the environment for student-athletes
              engaging in name, image, and likeness activities in college sports. Among the
              proposals the working group is expected to present to the council in October
              2023 are rules that would:
            </h2>
            <h2>
              <ul>
                <li>
                  Develop a registration process for NIL service providers (such as agents
                  and financial advisors) and NIL entities (those who contract with
                  student-athletes for the use of their NIL).
                </li>
                <li>
                  Create a standardized contract or standard contract terms that could
                  include certain information to be required, including terms like fee
                  structures and the specific activities for which athletes would be
                  compensated.
                </li>
                <li>
                  Establish disclosure requirements for student-athletes and/or NIL entities
                  that could serve as a resource for student-athletes and would be intended
                  to provide transparency about NIL activities.
                </li>
              </ul>
            </h2>
          </div>
          <div className="text-right">
            <Button color="danger" onClick={toggle2}>Close</Button>
          </div>
        </ModalBody>
      </AppModal>
    </>
  );
}
